
import Vue from "vue";
import { Action, State } from "vuex-class";
import { Component, Watch } from "vue-property-decorator";
import moment from "moment";
import { baseAPI } from "@/functions/apibase.function";
import { AxiosResponse } from "axios";
import { GuestPages } from "@/constants/guest.constant";

@Component({
  components: {},
})
export default class App extends Vue {
  private static readonly CHATFORGE_HIDDEN_CLASS = "hide-chatforge-widget";
  private static readonly CHATFORGE_ACTIVE_CLASS = "chatforge-widget-active";
  private chatForgeObserver: MutationObserver | null = null;

  @Action("getSelf", { namespace: "auth" })
  private getSelf: any;

  @State("locale")
  private locale!: string;

  @Watch("locale")
  private onLocaleChanged() {
    this.$i18n.locale = this.locale;
    moment.locale(this.locale);
  }

  @Watch("$route", { immediate: true })
  private onRouteChanged() {
    this.updateChatForgeVisibility();
    this.updateChatForgeState();
  }

  private created() {
    this.$i18n.locale = this.locale;
    moment.locale(this.locale);

    this.watchChatForgeWidget();
    this.getSelf();
    // this.websocket();
  }

  private beforeDestroy() {
    this.chatForgeObserver?.disconnect();
    document.body.classList.remove(App.CHATFORGE_ACTIVE_CLASS);
    document.body.classList.remove(App.CHATFORGE_HIDDEN_CLASS);
  }

  private watchChatForgeWidget() {
    this.updateChatForgeState();
    this.chatForgeObserver = new MutationObserver(() => this.updateChatForgeState());
    this.chatForgeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  private updateChatForgeState() {
    const chatbotExists = Boolean(
      document.querySelector(
        'iframe[src*="chatforge.srv1640038.hstgr.cloud"], [id*="chatforge"], [class*="chatforge"]'
      )
    );
    document.body.classList.toggle(
      App.CHATFORGE_ACTIVE_CLASS,
      chatbotExists && this.$route.path !== "/"
    );
  }

  private updateChatForgeVisibility() {
    const hiddenExactPaths = ["/", "/login", "/register", "/verify-email"];
    const shouldHideWidget =
      /^\/my-course\/.+/.test(this.$route.path) ||
      hiddenExactPaths.includes(this.$route.path);
    document.body.classList.toggle(App.CHATFORGE_HIDDEN_CLASS, shouldHideWidget);
  }

  private websocket() {
    (window as any).socket = new WebSocket(
      `wss://${baseAPI
        .replaceAll("https://", "")
        .replaceAll("http://", "")}/admin-job-fair-websocket`
    );
    (window as any).socket.onopen = () => {
      (window as any).socket.send(
        JSON.stringify({
          slug: this.$route.params.slug,
        })
      );
    };
    (window as any).socket.onclose = () => {
      this.websocket();
    };
    (window as any).socket.onerror = (event) => {
      console.log("onerror", event);
    };
    (window as any).socket.onmessage = (event) => {
      console.log("onmessage", event?.data);
    };
  }
}
